import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { OAuthService } from 'angular-oauth2-oidc';
import { LanguageService } from '../language.service';

@Component({
  selector: 'app-welcome',
  imports: [RouterLink, CommonModule],
  templateUrl: './welcome.component.html',
  styleUrl: './welcome.component.css'
})
export class WelcomeComponent {
  oauthService = inject(OAuthService);
  languageService = inject(LanguageService);

  get isLoggedIn(): boolean {
    return this.oauthService.hasValidAccessToken();
  }


  trackByRandom(index: number): number {
    return Math.random();
  }



}
